import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import status from './status'

export default new Vuex.Store({
  modules: {
    status
  }
})
